export default {
  payWelfareText: 'โบนัสเติมเงิน',
  blackFridayDiscount: 'ลดกระหน่ำ แบล็คฟรายเดย์',
  shareGift: 'แชร์ทันทีมีรางวัล',
  vipWeeklyWelfare: 'โปรฯ VIP ประจำสัปดาห์',
  exchangeCoupon: 'แลกคูปอง',
  firstPayOff: 'ซื้อครั้งแรก รับส่วนลดสูงสุด 15%',
  blackFridayEvent: 'กิจกรรมแบล็คฟรายเดย์',
  limitedTimeOff: 'ลดทันที 10%',
  claimCoupon: 'รับคูปอง',
  blackFridayTimedCoupon: 'คูปองแบล็คฟรายเดย์',
  timeLeft: 'เหลือเวลา:',
  claimTimeCoupon: 'รับคูปองลด 10% จำนวนจำกัด',
  points: 'คงเหลือพอยท์: ${point}',
  costPointTip: 'ใช้พอยท์รับคูปองระดับใดก็ได้',
  maxPointTip: 'ใช้ได้สูงสุดบัญชีละ 500 พอยท์',
  discountOff: 'ลด 10%',
  highestDiscount: 'ลดสูงสุด ${discount} ',
  needPoint: 'ต้องใช้พอยท์ ${point}',
  changeCurrency: 'เปลี่ยนสกุลเงิน',
  claim: 'รับ',
  claimSucc: 'รับสำเร็จ',
  claimFail: 'รับล้มเหลว',
  pointNotEnough: 'พอยท์ไม่เพียงพอ',
  afterClaimPoint: 'หลังรับจะเหลือพอยท์: ${point}',
  footTips1: 'ใช้คูปองได้ 1 ใบ/1 การสั่งซื้อ',
  footTips2: 'ใช้คูปองนี้ร่วมกับคูปองเงินสดไม่ได้',
  footTips3:
    'ทีมงานขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
  ruleTitleText: 'กติกา',
  ruleTime: 'ระยะเวลา: 24 พ.ย. เวลา 00:00 น.- 26 พ.ย. เวลา 23:59 น.(UTC)',
  bfRuleText1:
    '1. ล็อกอินหน้าเว็บเติมเงินทางการครั้งแรกในช่วงกิจกรรม จะได้รับ 400 พอยท์ สามารถนำไปใช้แลกคูปองได้ สูงสุด 500 พอยท์',
  bfRuleText2:
    '2. ช่วงกิจกรรมสามารถใช้พอยท์แบล็คฟรายเดย์แลกคูปองยอดใดก็ได้ ยอดยิ่งสูง ยิ่งต้องใช้พอยท์มากตาม หลังแลกสำเร็จ จะหักพอยท์จำนวนที่สอดคล้อง',
  bfRuleText3:
    '3. ทุกๆ การสั่งซื้อใช้คูปองได้เพียง 1 ใบ และไอเทมคูปองเงินสดไม่สามารถใช้คูปองแบล็คฟรายเดย์',
  bfRuleText4: '4. คูปองแบล็คฟรายเดย์สนับสนุนสกุลเงินดังนี้ :',
  ableCoinsType:
    'USD, JPY, KRW, TWD, EUR, HKD, GBP, CAD, AUD, RUB, MYR, THB, PLN, IDR',
  bfRuleText5:
    '5. หลังแลกสำเร็จจะไม่สามารถเปลี่ยนสกุลเงินหรือขอคืนพอยท์ได้ โปรดตรวจสอบยอดเงินและการใช้พอยท์ก่อนแลก',
  bfRuleText6: '6. คูปองแบล็คฟรายเดย์มีอายุ 7 วัน',
  bfRuleText7:
    '7. ทีมงานขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
  thanksTip:
    'ขอบคุณสำหรับการสนับสนุน สามารถติดตามกิจกรรมเพิ่มเติมได้ทางโซเชียลของเรา',
  exchangePoints: 'แลกคูปอง',
  exchangeCode: 'โปรดเลือกช่องทางชำระเงินและป้อนโค้ดส่วนลด',
  enterExchangeCode: 'ป้อนโค้ดส่วนลดที่นี่',
  exchangeText: 'แลก',
  confirmGet: 'ยืนยันรับ',
  couponUsedWay:
    'สามารถใช้คูปองกับช่องทางชำระเงินของสกุลเงินที่กำหนดได้เท่านั้น โปรดยืนยันสกุลเงินที่ท่านต้องการใช้',
  confirmText: 'ยืนยัน',
  exchangeSucc: 'แลกสำเร็จ',
  aboutCoins: 'เกี่ยวกับคูปองเงินสด',
  aboutCoinsText:
    'คูปองเงินสดใช้แลกแพ็กและบริการเสริมทุกประเภทของเกมนี้ได้ ยกเว้นคูปอง',
  known: 'ทราบแล้ว',
  codeText: 'กิ๊ฟโค้ด',
  codeInvalid: 'กิ๊ฟโค้ดไม่เป็นผล!',
  hasExchanged: 'ท่านเคยแลกไปแล้ว สามารถแลกได้เพียง 1 ครั้ง!',
  hideText: 'ซ่อน',
  //黑五的报错码
  'bf-20001': 'ยังไม่ได้ล็อกอิน',
  'bf-20002': 'พารามิเตอร์ผิดพลาด โปรดลองร่วมกิจกรรมใหม่',
  'bf-20003': 'พอยท์ไม่เพียงพอ',
  'bf-20004': 'รับไม่สำเร็จ โปรดลองใหม่ภายหลังหรือติดต่อฝ่ายบริการลูกค้า',
  'bf-20005': 'รับแล้ว',
  'bf-20015': 'กิจกรรมยังไม่เริ่ม โปรดติดตาม',
  'bf-20016': 'กิจกรรมสิ้นสุดแล้ว',
  bfShareText: 'รับคูปองลด 10% จำนวนจำกัด',
  rightsCenterBtn: 'ศูนย์สมาชิก',
  payBtn: 'เติมเงิน',
  hasEqualRewardMuglo: 'เติมเงินผ่านเว็บเกม ได้รับโบนัสสูงสุด 1800 เพชร!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'เกียรติยศเหนือล้ำ(ถาวร)',
  rightCenterNoticeTitle: 'เกี่ยวกับการอัปเกรดระบบแต้ม VIP เป็น [ศูนย์สิทธิประโยชน์]',
  rightCenterNoticeContent: 'ผู้บัญชาการที่เคารพ:<br />ขอขอบคุณสำหรับการสนับสนุนที่ดีเสมอมา! เพื่อมอบประสบการณ์สิทธิประโยชน์ที่ดีกว่าเดิม เราจะทำการปรับปรุงระบบแต้ม VIP ที่มีอยู่เดิมทั้งหมดในวันที่ 16/7/2025 และเปิดตัวระบบใหม่ "ศูนย์สิทธิประโยชน์" การปรับปรุงครั้งนี้จะรวมสิทธิประโยชน์ VIP เดิม และเพิ่มสิทธิประโยชน์ใหม่ๆ ดังนี้:<br />1.คำอธิบายเนื้อหาการอัปเกรด<br />สิทธิประโยชน์การเข้าสู่ระบบรายสัปดาห์ยังคงเดิม<br />16 ก.ค. - 29 ก.ค. 2025 ผู้เล่นทุกท่านยังคงสามารถรับ [คูปอง VIP รายสัปดาห์] ได้ที่ [หน้าเติมเงินเว็บไซต์หลัก] โดยจำนวนคูปองที่ได้รับจะเท่ากับ [กิจกรรมแต้ม VIP] และสามารถแลกคูปองเวอร์ชันใหม่ได้ที่ [ศูนย์สิทธิประโยชน์] ทั้งนี้ คูปองในศูนย์สิทธิประโยชน์จะมีวงเงินสูงสุดในการใช้เป็นส่วนลด โปรดตรวจสอบกฎและจำนวนคูปองที่ได้รับได้จากตารางด้านล่าง<br />หมายเหตุ: ฟังก์ชั่นการแจกตั๋วโปรโมชั่นอัตโนมัติต้องเปิดใช้งานด้วยตนเอง มีขั้นตอนดังนี้: หน้าแรกศูนย์สิทธิประโยชน์ - ดูสิทธิประโยชน์สมาชิก - การแจกตั๋วโปรโมชั่นอัตโนมัติ - คลิกเปิด - เลือกตั๋วโปรโมชั่นที่ต้องการแลกอัตโนมัติ - ยืนยันการเปิดใช้งาน<br />เพิ่มสิทธิประโยชน์แลกแต้ม<br />ศูนย์สิทธิประโยชน์จะเปิดฟังก์ชัน [แลกแต้ม] ผู้เล่นสามารถรับแต้มได้จากการล็อกอินเข้าเกม การทำเควสที่กำหนดในศูนย์สิทธิประโยชน์ และอื่นๆ เพื่อนำมาแลกตั๋วโปรโมชั่นสุดพิเศษ ไอเทมแรร์ และรางวัลสุดคุ้มอื่นๆ (ดูจำนวนที่แลกได้ในหน้าศูนย์สิทธิประโยชน์)<br />รับประกันการสืบทอดเลเวล VIP<br />สิทธิ์ VIP เดิมและแต้มสะสมทั้งหมดจะถูกโอนไปยังศูนย์สิทธิประโยชน์ และแปลงเป็นระดับสมาชิกที่ตรงกันโดยอัตโนมัติ สิทธิพิเศษ VIP เดิมจะยังคงอยู่และได้รับการอัปเกรด<br />2.ข้อดีหลังการปรับปรุง<br />สิทธิประโยชน์โปร่งใสยิ่งขึ้น: กฎและเนื้อหาสำหรับแลกรางวัลทั้งหมดแสดงอย่างชัดเจน รับได้ง่ายในคลิกเดียว<br />ของสมนาคุณมากขึ้น: เพิ่มกิจกรรมแลกแต้ม ไอเทมคุณภาพสูงอัปเดตเป็นระยะ<br />โบนัสจับรางวัล: นอกจากการแลกแต้มแล้ว ยังมีกิจกรรมจับรางวัลเพื่อรับรางวัลไอเทมภายในเกมอีกด้วย<br />3.ข้อควรระวัง<br />ช่วงเปลี่ยนผ่าน (16/7/2025 - 29/7/2025) ทางเข้าแต้ม VIP เดิมจะปิดลงตามลำดับ (แต่ยังคงแจกคูปองตามปกติก่อนปิดให้บริการ) โปรดใช้คูปองที่เหลือให้ทันเวลา คูปองที่ไม่ได้ใช้หลังจาก [กิจกรรมแต้ม VIP] ปิดให้บริการแล้วจะถือเป็นโมฆะ<br />หลังจากเปิดศูนย์สิทธิประโยชน์แล้ว คุณสามารถเข้าสู่ [ศูนย์สิทธิประโยชน์] ได้ผ่าน [หน้าเติมเงินเว็บไซต์หลัก] - [โปรไฟล์]',
  rightCenterNoticeTableTitle: 'การเปรียบเทียบการเปลี่ยนแปลงคูปอง',
  rightCenterNoticeTableHeader1: 'เกณฑ์การแลกเปลี่ยน - ระดับศูนย์สมาชิก',
  rightCenterNoticeTableHeader2: 'ระดับ VIP เดิม',
  rightCenterNoticeTableHeader3: 'ส่วนลดตั๋วโปรโมชั่น',
  rightCenterNoticeTableHeader4: 'ขีดจำกัดการรับ',
  rightCenterNoticeTableHeader5: 'ขีดจำกัดการลด',
  rightCenterNoticeTableLevel1: 'บรอนซ์',
  rightCenterNoticeTableLevel2: 'ซิลเวอร์',
  rightCenterNoticeTableLevel3: 'โกลด์',
  rightCenterNoticeTableLevel4: 'แพลทตินั่ม',
  rightCenterNoticeTableLevel5: 'ไดมอนด์',
  rightCenterNoticeTableCount1: '1 ครั้ง/วัน',
  rightCenterNoticeTableCount2: '15 ครั้ง/เดือน',
  rightCenterNoticeTableCount3: '10 ครั้ง/เดือน',
  rightCenterNoticeTableLimit: '15 USD',
  rightCenterNoticeTableTip: 'หมายเหตุ: วงเงินส่วนลดสูงสุดของตั๋วโปรโมชั่น [ศูนย์สิทธิประโยชน์] ใช้ USD เป็นเกณฑ์ ซึ่งอาจมีการเปลี่ยนแปลงตามอัตราแลกเปลี่ยน โดยอ้างอิงจากข้อมูลที่แสดงบนหน้าใช้งานจริง',
  '-': '-'
};
